import Utility, { notifyPlacement, notifyType } from "./utility";

const handleRsponse = {
    handleAxios, getResponse
}
function handleAxios(axiosResponse, setResponse, setIsLoad) {

    setIsLoad(false);
    axiosResponse
        .then(response => {
            if (setResponse != null)
                setResponse({ status: response.status, data: response.data });
            else {
                Utility.openNotification((response.data.isSuccess) ? notifyType.success : notifyType.error, notifyPlacement.bottomLeft, '', response.data.data);
            }
            setIsLoad(true);
        })
        .catch(error => {
            // console.log(error.response.data.message, 'catch');
            if (error.response != undefined)
                //setResponse({ status: error.response.status, data: error.response.data });
                Utility.openNotification(notifyType.error, notifyPlacement.bottomLeft, 'خطا', error.response.data.message);
            else
                //setResponse({ status: 500, data: 'خطا سرویس دهنده' });
                Utility.openNotification(notifyType.error, notifyPlacement.bottomLeft, 'خطا', 'خطا سرویس دهنده');
            setIsLoad(true);
        })
}
function getResponse(response) {
    if (response.status === 200)
        return (response.data.data);
    else {
        Utility.openNotification(notifyType.error, notifyPlacement.bottomLeft, 'خطا', response.data);
        return null;
    }
}
export default handleRsponse;
// userRepository.getUser('id')
        // .then(response=>{setUser(response.data);setIsLoaded(true);})
        // .catch(error => {console.log(error.response,'error');setIsLoaded(true); })
        //handleRsponse.handleAxios(userRepository.getUser(id),setUser,setIsLoaded); 
